import { I18n } from '@/services/i18n';

type Message = {
  title: string;
  description: string;
  chooseMessage: string;
  writeNice: string;
  tapToWrite: string;
  send: string;
  disableSmartMessages: string;
  howItWorks: string;
  step1: string;
  step2: string;
  step3: string;
  step4: string;
};

const messages: I18n<Message> = {
  en: {
    title: 'Use free Chat Request',
    description:
      'Send 5 free Chat Requests before a match. After that, Smart Messages turns on automatically.',
    chooseMessage: 'Choose first message:',
    writeNice: 'Or write something nice...',
    tapToWrite: 'Tap to write',
    send: 'Send Chat Request',
    disableSmartMessages: 'Do not use Smart Messages',
    howItWorks: 'How does it work?',
    step1: 'We check your profile to find a fitting match.',
    step2: 'We send a friendly first message based on their profile.',
    step3: 'You take it from there — chat, connect, or move on.',
    step4: "It's free, private, and you can turn it off anytime in Settings.",
  },
  es: {
    title: 'Usa solicitud de chat gratis',
    description:
      'Envía 5 solicitudes de chat gratis antes de un match. Después de eso, los Mensajes Inteligentes se activan automáticamente.',
    chooseMessage: 'Elige el primer mensaje:',
    writeNice: 'O escribe algo bonito...',
    tapToWrite: 'Toca para escribir',
    send: 'Enviar solicitud de chat',
    disableSmartMessages: 'No usar Mensajes Inteligentes',
    howItWorks: '¿Cómo funciona?',
    step1: 'Revisamos tu perfil para encontrar una coincidencia adecuada.',
    step2: 'Enviamos un primer mensaje amistoso basado en su perfil.',
    step3: 'Tú tomas el control desde ahí: chatea, conecta o sigue adelante.',
    step4: 'Es gratis, privado y puedes desactivarlo en cualquier momento en Configuración.',
  },
  de: {
    title: 'Kostenlose Chat-Anfrage verwenden',
    description:
      'Sende 5 kostenlose Chat-Anfragen vor einem Match. Danach werden Smart Messages automatisch aktiviert.',
    chooseMessage: 'Erste Nachricht wählen:',
    writeNice: 'Oder schreibe etwas Nettes...',
    tapToWrite: 'Tippe zum Schreiben',
    send: 'Chat-Anfrage senden',
    disableSmartMessages: 'Smart Messages nicht verwenden',
    howItWorks: 'Wie funktioniert es?',
    step1: 'Wir prüfen dein Profil, um ein passendes Match zu finden.',
    step2: 'Wir senden eine freundliche erste Nachricht basierend auf ihrem Profil.',
    step3: 'Von da an übernimmst du: chatten, verbinden oder weitergehen.',
    step4: 'Es ist kostenlos, privat und du kannst es jederzeit in den Einstellungen deaktivieren.',
  },
};

export { messages };
